import { render, staticRenderFns } from "./ships-icon.svg.vue?vue&type=template&id=5a04c486&"
import script from "./ships-icon.svg.vue?vue&type=script&lang=js&"
export * from "./ships-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports